import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getUserLanguage } from './storage';

import enTranslations from '../locales/en.json';
import esTranslations from '../locales/es.json';
import mlTranslations from '../locales/ml.json';
import ruTranslations from '../locales/ru.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      ml: { translation: mlTranslations },
      ru: { translation: ruTranslations },
    },
    lng: getUserLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
